var spBreak = 767;
function isMobile() {
  return window.matchMedia('(max-width: ' + spBreak + 'px)').matches;
}

$(document).ready(function () {
  //   // isMobile
  //   if ($('.ct-faq').length) {
  //     $('dl dt').on('click', function () {
  //       $(this).next('dd').slideToggle();
  //       $(this).parent('.ct-faq dl').toggleClass('_close');
  //     })
  //     $('.close').on('click', function () {
  //       $(this).parent().slideUp();
  //       $(this).parents('dl').removeClass('_close');
  //     });
  //   }

  // newstopics
  $('.p-news .box-select select').on('change', function () {
    var url = $(this).val();
    if (url != '') {
      location.href = url;
    }
  });

  // Page Business Entry
  $('#sendChkbox').on('click', function () {
    var checked_status = this.checked;
    if (checked_status == true) {
      $('.btn-submit').removeAttr('disabled');
    } else {
      $('.btn-submit').attr('disabled', 'disabled');
    }
  });
  $('#sendEntry').on('click', function () {
    window.open('https://forms.gle/Zo7LbJf49htRV3y76', '_blank');
    return false;
  });
});

// $( document ).ready(function() {
//   function goToByScroll(id) {
//     // Remove "link" from the ID
//     id = id.replace("link", "");
//     // Scroll
//     $('html,body').animate({
//         scrollTop: $("#" + id).offset().top
//     }, 'slow');
//   }

//   $('.tabs-nav a').click(function() {
//     if (!$(this).parent().hasClass('active')) {
//       var currentTab = $(this).attr('href');
//       var r = currentTab.split("#");
//       var timer = 0;
//       // Check for active
//       $('.tabs-nav li').removeClass('active');
//       if ($(this).parents('.tabs-nav').hasClass('tabs-nav_end')) {
//           goToByScroll(r[1]);
//           timer = 300;
//       }
//       $('a[href$="'+r[1]+'"]').parent().addClass('active');
//       // Display active tab
//       setTimeout(function() {
//         $('.tabs-content .tab_inner').hide();
//         $(currentTab).show();
//       }, timer);
//     }

//     if (isMobile()) {
//       $('.bnt-fix').slideDown();
//     }

//     return false;
//   });
// });

// if iframe in youtube
function videoControl(action, targetVideo) {
  var $playerWindow = targetVideo[0].contentWindow;
  $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
}
function iframeReset() {
  var youtubeElement = $('.box-modal_youtube .box-youtube');
  if (youtubeElement.length) {
    var youtubeURL = youtubeElement.prop('src');
    youtubeElement.prop('src', '');
    youtubeElement.prop('src', youtubeURL);
  }
}

$(document).ready(function () {
  $('.link,.link-modal').on('click', function (e) {
    e.preventDefault();
    var t = $(this).find('a').attr('data-modal');
    $(".modal-facility[data-open='" + t + "']").addClass('modal-facility-visible');
    $(".modal-facility[data-open='" + t + "']").css('height', 'auto');
    var _tempPosY = $(window).scrollTop();
    $('body').css('overflow', 'hidden');
    localStorage.setItem('posY', _tempPosY);

    if ($('.wrap').length > 1) {
      $('#link-' + t).addClass('active');
    } else {
      $('.wrap').addClass('active');
    }
  });
  $('.in_modal-ground .close-item').on('click', function (e) {
    e.preventDefault();
    var y = localStorage.getItem('posY');
    $('.modal-facility').removeClass('modal-facility-visible');
    $('body').css('overflow', 'inherit');
    $('html, body').scrollTop(y);
    localStorage.clear();
    $('.wrap').removeClass('active');

    // if iframe in youtube
    iframeReset();
  });

  $('.modal-facility')
    .on('click', function (e) {
      var y = localStorage.getItem('posY');
      $('.modal-facility').removeClass('modal-facility-visible');
      $('body').css('position', '');
      $('body').css('overflow', 'inherit');
      $('html, body').scrollTop(y);
      localStorage.clear();
      $('.wrap').removeClass('active');

      // if iframe in youtube
      iframeReset();
    })
    .on('click', '.inner-content', function (e) {
      // clicked on descendant div
      e.stopPropagation();
    });
});

$(document).ready(function () {
  $('.anchor_link a[href^="#"]').click(function () {
    var speed = 600;
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top - 80;
    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });
});

// pageup
$(document).ready(function () {
  var backTop = $('.pageup');
  backTop.click(function () {
    $('html, body').animate(
      {
        scrollTop: 0,
      },
      500
    );
    return false;
  });

  $('.bt-close').on('click', function () {
    $('.bnt-fix').slideUp();
  });

  // Scroll Banner Youtube
  // var target = $('.wrapp-bnr_youtube');
  // setTimeout(function () {
  //   target.addClass('_view');
  // }, 1000);
  // target.find(' .btn_close').on('click', function () {
  //   target.fadeOut();
  // });

  // Scroll Banner Youtube Allpage
  // var target = $('.wrapp-bnr_youtube-allpage');
  // if ($.cookie('wrappBnrYoutubeAllpage') != 'isClicked') {
  //   setTimeout(function(){target.addClass('_view');}, 1000);
  // }
  // target.find(' .btn_close').on('click', function() {
  //   target.fadeOut();
  //   var date = new Date();
  //   date.setTime(date.getTime() + (12*60*60*1000));
  //   $.cookie('wrappBnrYoutubeAllpage', 'isClicked', { expires: date , path: "/" });
  // });

  // $(document).scroll(function () {
  //   if ($(window).width() > 767) {
  //     if ($(window).scrollTop() > 0) {
  //       if (!target.hasClass('_fixed')) {
  //         target.css('top', '');
  //         target.animate({ bottom: '30px' }, 150, 'linear');
  //       }
  //       target.addClass('_fixed');
  //     } else {
  //       target.css('bottom', '');
  //       target.removeClass('_fixed');
  //     }
  //   }

  //   scrollHeight = $(document).height();
  //   scrollPosition = $(window).height() + $(window).scrollTop();
  //   footHeight = $('footer').innerHeight();
  //   if (scrollHeight - scrollPosition <= footHeight - 30) {
  //     target.addClass('_none');
  //   } else {
  //     target.removeClass('_none');
  //   }
  // });
});

// Toppage
$(window).on('load', function () {
  // よくある質問ページ
  if ($('.p-faq').length) {
    const hash = location.hash;
    if (hash.match(/#anchor-/)) {
      // アコーディオンの開閉
      $(hash).parents('dd').slideToggle();
      $(hash).parents('dl').toggleClass('_close');

      // アンカーリンクのスムーススクロール
      setTimeout(function () {
        let positioning = 110;
        if (isMobile()) {
          positioning = 80;
        }
        const href = hash,
          target = $(href == '#' || href == '' ? 'html' : href),
          position = target.offset().top - positioning;
        $('body,html').animate({ scrollTop: position }, 600, 'swing');
      }, 1000);
    }
  }

  // Modal Load Active
  if ($('#link-load-active').length || $('#top-load-link').length) {
    setTimeout(function () {
      var t = $('#link-load-active').find('a').attr('data-modal');
      $(".modal-facility[data-open='" + t + "']").addClass('modal-facility-visible');
      $(".modal-facility[data-open='" + t + "']").css('height', 'auto');
      var _tempPosY = $(window).scrollTop();
      $('body').css('overflow', 'hidden');
      localStorage.setItem('posY', _tempPosY);
      $(".modal-facility[data-open='" + t + "']")
        .parents('.wrap')
        .addClass('active');
    }, 300);
  }
  if ($('#top-load-active').length) {
    setTimeout(function () {
      var t = 'modalAttention';
      $(".modal-facility[data-open='" + t + "']").addClass('modal-facility-visible');
      $(".modal-facility[data-open='" + t + "']").css('height', 'auto');
      var _tempPosY = $(window).scrollTop();
      $('body').css('overflow', 'hidden');
      localStorage.setItem('posY', _tempPosY);
      $(".modal-facility[data-open='" + t + "']")
        .parents('.wrap')
        .addClass('active');
    }, 300);
  }

  // Toppage Slider
  // if ($('.slide1').length) {
  //   var mv_swiper1 = new Swiper ('.slide1', {
  //     speed: 1050,
  //     autoplay: {
  //       delay: 3900,
  //       disableOnInteraction: false,
  //     },
  //     loop: true,
  //     effect: 'fade',
  //     slidesPerView: 1,
  //     spaceBetween: 0,
  //     centeredSlides : true,
  //     pagination: {
  //       el: '.swiper-pagination',
  //       clickable: true
  //     },
  //   });
  // }

  // if ($('.slide3').length) {
  //   var mv_swiper3 = new Swiper ('.slide3', {
  //     speed: 1050,
  //     autoplay: {
  //       delay: 3900,
  //       disableOnInteraction: false,
  //     },
  //     loop: true,
  //     effect: 'fade',
  //     slidesPerView: 1,
  //     spaceBetween: 0,
  //     centeredSlides : true,
  //   });
  // }
});

$(document).ready(function () {
  const body = $('body');
  const header = $('.c-header');
  const menu = $('.js-menu-toggle');
  const menuLogo = $('.js-menu-logo');
  const menuButton = $('.js-bnt-menu');
  const bgOverflow = $('.bg-overflow');
  const bgOverflow2 = $('.bg-overflow2');
  $('.js-bnt-menu').on('click', function () {
    $(this).toggleClass('is-active');
    if ($(this).hasClass('is-active')) {
      menu.addClass('is-active');
      menuLogo.addClass('is-active');
      menuButton.addClass('is-active');
      bgOverflow.addClass('is-active');
      bgOverflow2.addClass('is-active');
      header.addClass('is-active');
      body.data('scrollY', window.scrollY);
      body.addClass('no-scroll').css({
        top: `-${body.data('scrollY')}px`,
      });

      $(window).on('touchmove.noScroll', function (e) {
        e.preventDefault();
      });
    } else {
      menu.removeClass('is-active');
      menuLogo.removeClass('is-active');
      menuButton.removeClass('is-active');
      bgOverflow.removeClass('is-active');
      bgOverflow2.removeClass('is-active');
      header.removeClass('is-active');

      body.removeClass('no-scroll').css({
        top: '',
      });
      window.scrollTo(0, parseInt(body.data('scrollY') || '0'));
      $(window).off('.noScroll');
    }

    if (bgOverflow.hasClass('is-active')) {
      let maxSize = Math.max(window.innerWidth, window.innerHeight);
      let scaleValue = maxSize / 47;
      requestAnimationFrame(() => {
        bgOverflow.css('transform', `translate(-50%, -50%) scale(${scaleValue})`);
      });
    } else {
      requestAnimationFrame(() => {
        bgOverflow.css('transform', 'scale(1)');
      });
    }
  });

  //Scroll header
  $(document).scroll(function () {
    const header = $('.c-header');
    const headerHeight = header.outerHeight();

    if ($(window).scrollTop() > headerHeight) {
      header.addClass('is-scroll');
    } else {
      header.removeClass('is-scroll');
    }
  });

  //Toggle accordion
  $('.js-accor-content').slideUp();
  if ($('.js-accor').length) {
    $('.js-accor-heading').on('click', function () {
      $(this).children('.ico_toggle').toggleClass('is-open');
      $(this).next('.js-accor-content').slideToggle();
    });
  }

  //Top slider
  if ($('.js-slider1').length) {
    var mv_swiper3 = new Swiper('.js-slider1', {
      // speed: 1050,
      // autoplay: {
      //   delay: 3900,
      //   disableOnInteraction: false,
      // },
      autoplay: false,
      loop: true,
      slidesPerView: 1.8,
      spaceBetween: 25,
      centeredSlides: true,
      speed: 16000,
      allowTouchMove: false, // Add
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 50,
          centeredSlides: false,
        },
      },
    });
  }

  let swiperInstance;
  function toggleSwiper() {
    let slider = $('.js-slider2');

    if (!slider) {
      return;
    }

    if ($(window).width() < 768) {
      if (!slider.hasClass('swiper-initialized')) {
        swiperInstance = new Swiper('.js-slider2', {
          slidesPerView: 1,
          loop: true,
          centeredSlides: true,
          spaceBetween: 30,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }
    } else {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }
  }

  toggleSwiper();
  $(window).resize(function () {
    toggleSwiper();
  });

  const renderTag = $('.js-handle-image');
  if (renderTag.length) {
    const arrImage = ['img_main1.jpg', 'img_main2.jpg', 'img_main2.jpg'];
    const randomImage = Math.floor(Math.random() * arrImage.length);
    const bgImage = arrImage[randomImage];
    const bgUrl = `${machinoriData.themeUrl}/img/top/${bgImage}`;
    renderTag.css('background-image', `url("${bgUrl}")`);
  }
});

$(window).on('load', function () {
  const speed = 500;
  const headerH = $('.c-header').outerHeight();

  const hash = window.location.hash;

  if (!hash == '' || !hash == undefined) {
    let target = $(hash);
    target = target.length ? target : $('[name=' + hash.slice(1) + ']');
    let position = target.offset().top - headerH;
    if (target.length) {
      $('html,body').stop().animate({ scrollTop: position }, 'swing');
    }
  }

  $('[data-scroll-link]').on('click', function (e) {
    let position;
    let href = $(this).attr('href');
    let target = $(href == '#' || href == '' ? 'html' : href);
    position = target.offset().top - headerH;
    $('html, body').animate({ scrollTop: position }, speed, 'swing');
    e.preventDefault();
  });
});

//Fixed sidebar
document.addEventListener('DOMContentLoaded', function () {
  let sidebar = document.querySelector('.c-sidebar1');
  let target = document.querySelector('.js-sidebar');
  let header = document.querySelector('.c-header');
  let footer = document.querySelector('.c-footer');

  if (!sidebar || !target || !header || !footer) return;

  let headerHeight = header.offsetHeight + 20;
  let sidebarTop = target.getBoundingClientRect().top + window.scrollY;

  window.addEventListener('scroll', function () {
    let scrollY = window.scrollY;
    let footerTop = footer.getBoundingClientRect().top + window.scrollY + 500;
    sidebar.style.top = `${headerHeight}px`;

    if (scrollY >= sidebarTop - headerHeight && scrollY + window.innerHeight < footerTop) {
      sidebar.classList.add('is-active');
    } else {
      sidebar.classList.remove('is-active');
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  let links = document.querySelectorAll('.c-sidebar1__link');
  let sections = [];

  links.forEach((link) => {
    let section = document.querySelector(link.getAttribute('href'));
    if (section) {
      sections.push({ link, section });
    }
  });

  function updateActiveLink() {
    let scrollPosition = window.scrollY + 200;

    sections.forEach(({ link, section }) => {
      let rect = section.getBoundingClientRect();
      let sectionTop = window.scrollY + rect.top;
      let sectionBottom = sectionTop + section.offsetHeight;

      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        links.forEach((l) => l.classList.remove('is-current'));
        link.classList.add('is-current');
      }
    });
  }
  window.addEventListener('scroll', updateActiveLink);
  updateActiveLink();

  const canvas = document.getElementById('circleCanvasBtn');
  if (!canvas) {
    return;
  }
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return;
  }
  const text = 'RESITER HERE RESITER HERE RESITER HERE ';

  function drawTextOnCanvas() {
    canvas.width = canvas.height = window.innerWidth < 768 ? 230 : 250; // Cập nhật kích thước canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height); // Xóa canvas trước khi vẽ

    let fontSize, radius, centerX, centerY;
    if (window.innerWidth < 768) {
      fontSize = 13.707;
      radius = 65;
      centerX = 115;
      centerY = 115;
    } else {
      fontSize = 22;
      radius = 105;
      centerX = 125;
      centerY = 125;
    }

    const angleStep = (2 * Math.PI) / text.length;
    ctx.font = `500 ${fontSize}px Barlow`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = '#009A80';

    for (let i = 0; i < text.length; i++) {
      const angle = i * angleStep - Math.PI / 2;
      const x = centerX + radius * Math.cos(angle);
      const y = centerY + radius * Math.sin(angle);

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle + Math.PI / 2);
      ctx.fillText(text[i], 0, 0);
      ctx.restore();
    }
  }

  drawTextOnCanvas();

  window.addEventListener('resize', drawTextOnCanvas);
});

// MVのアニメーション

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const targetElement = document.querySelector('.p-top .c-carousel1__heading__ttl1');

    if (targetElement) {
      targetElement.classList.add('js-active');
    }
  }, 450);
});
